import { Component, Input, ViewEncapsulation } from '@angular/core';
import { systemRolesRoute } from 'src/app/app-routing.module';
import { RegisterOptions } from 'src/app/common-components/register/models/register-options';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { RolePrivileges } from '../../models/role-privileges';
import { RoleOrderingOptions, RoleRegisterOptions } from '../../models/role-register-options';
import { RoleRegisterListItem } from '../../models/role-register-results.model';
import { selectQuickFilters } from '../../state/role-register.reducer';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-system-role-register-view',
    styleUrls: ['./system-role-register-view.component.scss'],
    templateUrl: './system-role-register-view.component.html',
    standalone: false
})
export class SystemRoleRegisterViewComponent extends EntityRegisterView<
   RoleRegisterListItem,
   RoleRegisterOptions,
   RoleOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => RegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() includeInactive: boolean;

   @Input() rolePrivileges: RolePrivileges;

   getRouterLink(id: number) {
      return `/${systemRolesRoute}/${id}`;
   }
}
